import { motion } from 'framer-motion';
import { openBookingModal } from './BookingModal';
import { useLanguage } from '../context/LanguageContext';

export default function CTABanner() {
  const { t } = useLanguage();

  return (
    <section data-testid="cta-banner" className="relative overflow-hidden">
      <div className="absolute inset-0 bg-cover bg-center" style={{ backgroundImage: `url(https://customer-assets.emergentagent.com/job_escape-nexus/artifacts/hxsynjog_1_Q6SgXXrm6AwioCUrA1r0_Q.jpg)` }} />
      <div className="absolute inset-0 bg-black/60" />
      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center py-12 sm:py-16">
        <motion.h2 initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="font-heading text-4xl sm:text-5xl lg:text-7xl tracking-tight uppercase text-white mb-6">
          {t('readyToTest')}
        </motion.h2>
        <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }} transition={{ delay: 0.2 }} className="font-sans text-base sm:text-lg text-white/80 mb-10 max-w-xl mx-auto">
          {t('ctaDesc')}
        </motion.p>
        <motion.button initial={{ opacity: 0, y: 10 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.4 }} onClick={openBookingModal} data-testid="cta-book-now-btn" className="inline-block font-heading tracking-widest uppercase bg-white text-brand px-10 py-4 rounded-full hover:bg-neutral-100 transition-colors text-lg shadow-xl">
          {t('bookNow')}
        </motion.button>
      </div>
    </section>
  );
}
